import React, { useEffect, useState } from 'react'

function SponsorLinkModal({ sponsorLinks = [], onClose }) {
    const [showToast, setShowToast] = useState(false)
    const [linkId, setLinkId] = useState('')

    useEffect(() => {
        if (showToast) {
            setTimeout(() => {
                setShowToast(false)
            }, 5000)
        }
    }, [showToast])

    return (
        <div className='link-modal'>
            <div className='modal-header'>
                <b className='headeing'>My Sponsor Links</b>
                <div onClick={onClose} className='pointer'>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 4L4 12" stroke="#0A0A0A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4 4L12 12" stroke="#0A0A0A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <div className='link-container'>
                {sponsorLinks?.map((link, index) => (
                    <div key={index} className='link-box'>
                        <div className='link-details'>
                            <label className='link-name'>{link.name}</label>
                            <label className='link-url'>{link.url}</label>
                        </div>
                        <div className='link-actions'>
                            <div className='flex flex-column align-items-center gap-1 relative pointer' onClick={() => {
                                navigator.clipboard.writeText(link?.url)
                                setShowToast(true)
                                setLinkId(index)
                            }}>
                                <span className={`toast-text ${showToast && index === linkId ? 'show' : ''}`}>Copied!</span>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.10923 12.3514C5.71813 12.3514 5.3871 12.2189 5.11613 11.9541C4.84516 11.6892 4.70968 11.3656 4.70968 10.9833V2.36803C4.70968 1.98574 4.84516 1.66216 5.11613 1.3973C5.3871 1.13243 5.71813 1 6.10923 1H12.6005C12.9915 1 13.3226 1.13243 13.5935 1.3973C13.8645 1.66216 14 1.98574 14 2.36803V10.9833C14 11.3656 13.8645 11.6892 13.5935 11.9541C13.3226 12.2189 12.9915 12.3514 12.6005 12.3514H6.10923ZM6.10923 11.2162H12.6005C12.6601 11.2162 12.7146 11.1919 12.7642 11.1434C12.8139 11.0949 12.8387 11.0416 12.8387 10.9833V2.36803C12.8387 2.30976 12.8139 2.2564 12.7642 2.20797C12.7146 2.15941 12.6601 2.13514 12.6005 2.13514H6.10923C6.04961 2.13514 5.99503 2.15941 5.94548 2.20797C5.89581 2.2564 5.87097 2.30976 5.87097 2.36803V10.9833C5.87097 11.0416 5.89581 11.0949 5.94548 11.1434C5.99503 11.1919 6.04961 11.2162 6.10923 11.2162ZM3.39955 15C3.00845 15 2.67742 14.8676 2.40645 14.6027C2.13548 14.3378 2 14.0143 2 13.632V3.88154H3.16129V13.632C3.16129 13.6902 3.18613 13.7436 3.23581 13.792C3.28535 13.8406 3.33994 13.8649 3.39955 13.8649H11.0521V15H3.39955Z" fill="#39424E" />
                                </svg>
                            </div>

                            <div className='pointer' onClick={()=> window.open(link.url, '_blank')}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.48874 15C2.07272 15 1.72059 14.8559 1.43235 14.5676C1.14412 14.2794 1 13.9273 1 13.5113V2.48874C1 2.07272 1.14412 1.72059 1.43235 1.43235C1.72059 1.14412 2.07272 1 2.48874 1H7.68315V2.23529H2.48874C2.42532 2.23529 2.36726 2.26172 2.31456 2.31456C2.26172 2.36726 2.23529 2.42532 2.23529 2.48874V13.5113C2.23529 13.5747 2.26172 13.6327 2.31456 13.6854C2.36726 13.7383 2.42532 13.7647 2.48874 13.7647H13.5113C13.5747 13.7647 13.6327 13.7383 13.6854 13.6854C13.7383 13.6327 13.7647 13.5747 13.7647 13.5113V8.31685H15V13.5113C15 13.9273 14.8559 14.2794 14.5676 14.5676C14.2794 14.8559 13.9273 15 13.5113 15H2.48874ZM6.12174 10.7461L5.25394 9.87827L12.8969 2.23529H9.64706V1H15V6.35294H13.7647V3.10309L6.12174 10.7461Z" fill="#39424E" />
                                </svg>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default SponsorLinkModal